"use strict";

const addSlideCounter = function (container, l) {
	const el = document.createElement("div");
	el.classList.add("counter-item");
	el.style.cursor = "pointer";

	for (let i = 0; i < l; i++) {
		const elClone = el.cloneNode(true);
		elClone.setAttribute("id", i + 1);
		container.appendChild(elClone);
	}

	return container.querySelectorAll(".counter-item");
};

export default addSlideCounter;
